'use client';

import { useState, useEffect } from 'react';
import SearchBar from '@/componentv2/searchBar/searchBar';
import SearchResults from '../searchResults';

interface SearchableBlogSectionProps {
  children?: React.ReactNode;
  clearSearchSignal?: number;
}

const SearchableBlogSection = ({
  children,
  clearSearchSignal,
}: SearchableBlogSectionProps) => {
  const [searchQuery, setSearchQuery] = useState('');

  const handleSearch = (query: string) => {
    setSearchQuery(query);
  };

  // Listen for clearSearchSignal changes to clear search
  useEffect(() => {
    setSearchQuery('');
  }, [clearSearchSignal]);

  // Listen for custom clear search event
  useEffect(() => {
    const handleClearSearch = () => {
      setSearchQuery('');
    };

    window.addEventListener('clearBlogSearch', handleClearSearch);

    return () => {
      window.removeEventListener('clearBlogSearch', handleClearSearch);
    };
  }, []);

  return (
    <>
      <SearchBar onSearch={handleSearch} placeholder="Search blog posts..." />
      {searchQuery ? <SearchResults searchQuery={searchQuery} /> : children}
    </>
  );
};

export default SearchableBlogSection;
